import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useOutsideClick } from '../../../hooks';
import Loader from '../../SimpleLoader';
import { SelectorContainer, PostingsOption, Header, LoaderWrapper } from './styles';

const OptionsSelector = ({
  isOpen,
  elementRef,
  handleOutsideClick,
  width = '171px',
  height = 'fit-content',
  getTopPosition = false,
  topUp = '0px',
  topDown = '0px',
  left = '0px',
  right = '0px',
  justifyContent = 'center',
  padding = '8px 0px',
  children = null,
  optionsArray = [],
  hasSetUnmountComponent = false,
  title = '',
  colorTitle = 'black',
  textInfo = '',
  isLoading = false
}) => {
  const getOutsideOnClick = () => {
    if (isOpen) handleOutsideClick(isOpen);
  };

  useOutsideClick(elementRef, getOutsideOnClick);

  useEffect(() => {
    return () => {
      if (hasSetUnmountComponent) getOutsideOnClick();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SelectorContainer
      isOpen={isOpen}
      ref={elementRef}
      width={width}
      height={height}
      upPosition={getTopPosition}
      topUp={topUp}
      topDown={topDown}
      left={left}
      right={right}
      justifyContent={justifyContent}
      padding={padding}
      data-panel='options-container'
    >
      {isLoading ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          {(title || textInfo) && (
            <Header colorTitle={colorTitle}>
              <div className='containerHeader'>
                <div className='title'>{title}</div>
                <div className='textInfo'>{textInfo}</div>
              </div>
              <div className=' separator' />
            </Header>
          )}
          {optionsArray &&
            !children &&
            optionsArray.map(item => (
              <PostingsOption
                key={item.id}
                onClick={item.handleOnClick}
                data-panel={`option-${item.text}`}
                colorSpan={item.colorSpan}
              >
                {item.icon && (
                  <img
                    src={item.icon}
                    width='20px'
                    height='20px'
                    alt={`option-${item.text}-icon`}
                    data-panel={`option-${item.text}-icon`}
                  />
                )}
                <div data-panel={`option-${item.text}-text`}>{item.text}</div>
              </PostingsOption>
            ))}
          {children}
        </>
      )}
    </SelectorContainer>
  );
};

OptionsSelector.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default OptionsSelector;
